export const getCategoryTextPathId = (categoryName: string, isId = false) =>
  `${isId ? '#' : ''}textPath-${categoryName}`;
